import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the given URL only if it is safe to use as an href/src:
 * an http(s) URL, or a relative/root-relative path. Returns undefined
 * for anything else (e.g. `javascript:` URLs) to prevent script execution
 * from stored/user-provided links.
 */
export function safeHref(url?: string | null): string | undefined {
  if (!url) return undefined;
  // Allow relative and root-relative paths.
  if (url.startsWith("/")) return url;
  try {
    const parsed = new URL(url, window.location.origin);
    if (parsed.protocol === "http:" || parsed.protocol === "https:") {
      return url;
    }
  } catch {
    return undefined;
  }
  return undefined;
}
